import React, { useContext } from 'react';
import { getCombinedSuggestions } from '../../utils/suggestionsUtils';
import { useRecentSearchData, useLxpSmartFillAPI } from '../../hooks/apiHooks';
import locationContext from '../../context/locationsContext';
import SuggestionsList from '../Suggestions/SuggestionsList';

const LxpSmartFill = () => {
  const {
    config: {
      lineOfBusiness,
      maximumResultsToShow,
    },
  } = useContext(locationContext);
  const recentSearches = useRecentSearchData();
  const { suggestions, isLoading, error } = useLxpSmartFillAPI();

  if ((isLoading || error || suggestions?.length === 0) && recentSearches?.length === 0) {
    return null;
  }

  const suggestionsByType = getCombinedSuggestions({
    suggestions, recentSearches, maximumResultsToShow, lineOfBusiness,
  });

  return <SuggestionsList suggestions={suggestionsByType} />;
};

export default LxpSmartFill;
